import $axios from 'axios';
import store from '../store/index';

const instance = $axios.create({
    baseURL: 'https://cmst.xyz/mobile/',
    'headers': {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization' : `Bearer ${localStorage.getItem('token')}`
    }
});

instance.interceptors.request.use(config => {
    return config;

}, error => {
    api.handleError(error);
    return Promise.reject(error);
});

let api = {

    get: async function (target) {
        store.commit('LINEAR_LOADER',true);
        return await instance.get(target)
        .then((response) => {
            store.commit('LINEAR_LOADER',false);
                return response.data;
            },
        ).catch(e => {
            store.commit('LINEAR_LOADER',true);
            this.handleError(e);
        })
    },

    getWithPayload: function (target, payload) {
        store.commit('LINEAR_LOADER',true);
        return instance.get(target, { params: payload }).then(
            (response) => {
                store.commit('LINEAR_LOADER',false);
                return response.data;
            },
        ).catch(e => {
            store.commit('LINEAR_LOADER',true);
            this.handleError(e);
        });
    },


    post: function (target, payload) {
        store.commit('LINEAR_LOADER',true);
        return instance.post(target, payload).then(
            (response) => {
               store.commit('LINEAR_LOADER',false);
               return response.data;
            },
        ).catch(e => {
            store.commit('LINEAR_LOADER',true);
            this.handleError(e);
        });;
    },


    delete: function (target) {
        return instance.delete(target).then(
            (response) => response.data,
        ).catch(e => {
            this.handleError(e);
        });
    },

    handleError: function (error) {
        let errorCode = error.response.status;
        if (errorCode === 403) {
            console.log('handle forbidden');
        }
        if (errorCode === 401) {
            console.log('unauthentication response')
        }
        return Promise.reject(error);
    },
};

export default api;



// WEBPACK FOOTER //
// ./src/services/axios.js